var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"copyright"},[_c('a',{attrs:{"href":"https://github.com/maxSedelnikov","target":"_blank"}},[_c('b-icon-emoji-smile-upside-down'),_c('span',[_vm._v("Maxim Sedelnikov")])],1)])}
var staticRenderFns = []

export { render, staticRenderFns }